import { useState } from "react";
import "./index.less";
import classNames from "classnames";
import Account from "@/layout/components/Login/components/Account";
import Code from "@/layout/components/Login/components/Code";
import logPng from "@/images/logo.png";
import { useNavigate } from "react-router";

const Login = () => {
  const navigate = useNavigate();
  const [logoType, setLogoType] = useState("account");

  const changeLogoType = (e: any) => {
    const type = e.target.getAttribute("data-type");
    if (type && logoType !== type) {
      setLogoType(type);
    }
  };

  const goHome = () => {
    navigate("/home");
  };

  return (
    <article className="login-wrapper">
      <div className="top-logo">
        <img onClick={goHome} src={logPng} alt="" />
      </div>
      <div className="login-content">
        <ul className="logo-type flex" onClick={changeLogoType}>
          <li
            className={classNames([{ active: logoType === "account" }])}
            data-type="account"
          >
            账号登录
          </li>
          <li
            className={classNames([{ active: logoType === "code" }])}
            data-type="code"
          >
            验证码登录
          </li>
        </ul>
        {logoType === "account" ? <Account /> : <Code />}
      </div>
    </article>
  );
};

export default Login;
